import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Coins, Shield, GraduationCap, Trophy, Users, TrendingUp, Building2, Sprout, Rocket, BarChart3, Megaphone, ShieldCheck, Landmark, BadgeCheck, Store } from "lucide-react";

export const ICONS = { Coins, Shield, GraduationCap, Trophy, Users, TrendingUp, Building2, Sprout, Rocket, BarChart3, Megaphone, ShieldCheck, Landmark, BadgeCheck, Store };
export const NAVY = "#0B2E4F";
export const BLUE = "#006090";

export const STATUS = {
  complete: { label: "Completed", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "bg-emerald-500" },
  in_progress: { label: "In Progress", cls: "bg-amber-50 text-amber-700 border-amber-200", dot: "bg-amber-500" },
  not_started: { label: "Not Started", cls: "bg-slate-50 text-slate-600 border-slate-200", dot: "bg-slate-300" },
  needs_attention: { label: "Needs Attention", cls: "bg-rose-50 text-rose-700 border-rose-200", dot: "bg-rose-500" },
};

export function StatusPill({ p, testId }) {
  if (!p) return <span className="text-[11px] text-slate-400" data-testid={testId}>Not tracked yet</span>;
  const s = STATUS[p.status] || STATUS.not_started;
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[11px] font-semibold ${s.cls}`} data-testid={testId}>
      <span className={`w-1.5 h-1.5 rounded-full ${s.dot}`} />{p.status === "complete" ? s.label : p.total > 1 ? `${p.done} of ${p.total} Complete` : s.label}
    </span>
  );
}

export function SectionHead({ eyebrow, title, text, id, right }) {
  return (
    <div className="flex items-end justify-between gap-4 flex-wrap mb-6" id={id}>
      <div className="max-w-2xl">
        {eyebrow && <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-[#006090]">{eyebrow}</p>}
        <h2 className="font-display text-2xl sm:text-[28px] font-bold text-slate-900 mt-1 leading-tight">{title}</h2>
        {text && <p className="text-sm sm:text-base text-slate-600 mt-2">{text}</p>}
      </div>
      {right}
    </div>
  );
}

export function useBlobUrl(path) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (!path) { setUrl(null); return undefined; }
    let live = true, made = null;
    setUrl(null);
    api.get(path, { responseType: "blob" }).then((r) => { if (live) { made = URL.createObjectURL(r.data); setUrl(made); } }).catch(() => { if (live) setUrl("error"); });
    return () => { live = false; if (made) URL.revokeObjectURL(made); };
  }, [path]);
  return url;
}

export async function downloadDoc(doc) {
  const r = await api.get(`/acquisition/documents/${doc.id}/file`, { params: { download: true }, responseType: "blob" });
  const u = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = u; a.download = doc.filename || "document"; a.click();
  setTimeout(() => URL.revokeObjectURL(u), 2000);
}

export const fmtDate = (d) => d ? new Date(`${d}T12:00:00`).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : null;
export const money = (n) => (n == null ? "—" : `$${Math.round(n).toLocaleString()}`);
